"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "boissano": {
    "fd2b2b38": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "baroni": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a8001e1b": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "berruti": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a7f41bb2": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "bonfanti": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "554ee3d2": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "bosseri": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1c9c79c6": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "cavi": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e641be98": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "gandarini": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c581c34b": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "gandolfi": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9d1dc146": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "mogli": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "cac44496": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "piazza": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7d214b12": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "pogli": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f2da2349": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "pozzo": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7e45e042": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "skipSearch": false
    }],
    "sottani": [{
      "hkey": "aeea4ff4",
      "slug": "boissano",
      "name": "Boissano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;